@if (!uploadMediaContainer) {
  <mat-progress-bar
    mode="indeterminate"
    [attr.aria-label]="'TRANS__SEARCH__LOADING_INFO' | translate"
  ></mat-progress-bar>
}
@else {
  <div class="adminEventCreate operation-view-upload">
    <div
      class="row operation-view-upload__selector-general"
      [ngClass]="{'disabled': parentObject.$$annotateImage}"
    >
      <app-media-selector-general
        [uploadInfo]="uploadMediaContainer.uploadInfo"
        [parentObject]="operationContainer.contentInfo.artifact"
        [files]="uploadMediaContainer.files"
        (deleteImage)="handleDeleteImage($event)"
        (uploadComplete)="handleUploadComplete()"
      ></app-media-selector-general>
    </div>

    <div class="row operation-view-upload__uploaded-content">
      @if (uploadMediaContainer.files.length) {
      <span class="operation-view-upload__uploaded-headline bold">
        {{ 'TRANS__IMAGE_SELECTOR__STEP_2_HEADLINE' | translate }}
      </span>

      <span class="operation-view-upload__uploaded-description">
        {{ 'TRANS__IMAGE_SELECTOR__STEP_2_DESCRIPTION' | translate }}
      </span>

      <hr>
      }

      <div>
        <app-media-list
          [uploadMediaContainer]="uploadMediaContainer"
          [parentObject]="parentObject"
          (deleteMedia)="handleDeleteImage($event)"
        ></app-media-list>
      </div>
    </div>
  </div>
}
